function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.72729,
  y: 2.72726,
  width: 21.8182,
  height: 21.8182,
  stroke: "#222222"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5455 5.45456H27.2728V27.2727H5.45459V24.5455",
  stroke: "#222222"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.78713 8.42813C10.8085 7.40364 12.192 6.82506 13.6366 6.81818C15.0811 6.82506 16.4644 7.40376 17.4857 8.42822C18.5072 9.45259 19.0841 10.8402 19.091 12.2889V12.4722C19.0889 13.8059 18.5964 15.092 17.7078 16.0844L14.341 19.6702L13.6366 20.4545L12.9318 19.6964L9.74784 16.1105C8.77664 15.0721 8.21943 13.7121 8.18188 12.2888C8.18875 10.8401 8.76566 9.4525 9.78713 8.42813Z",
  stroke: "#222222"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.6365,
  cy: 12.2727,
  r: 2.22727,
  stroke: "#222222"
});

var SvgPlan = function SvgPlan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plan.246c333a.svg";
export { ForwardRef as ReactComponent };